module.exports = __webpack_public_path__ + "15_ldav_teaser2.png?c9b1a605e974b79fa3a1830b297e9b99";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/15_ldav_teaser2.png
// module id = 143
// module chunks = 0